module.exports = __webpack_public_path__ + "img/_icon_disapproved.75e9c10e.svg";